// Capture Google Ads attribution params (gclid + utm_*) from the landing-page
// URL into cookies, so the PHP backend can read them at form-submission time
// and pass them to Moveware (see MovewareHelper::getGoogleClickId/getGoogleTags).
//
// The old site had this snippet; it was lost in the rebuild, leaving the intact
// backend with no cookies to read. Runs on the initial full-page load only —
// Livewire SPA navigations don't reload, and the gclid is only present in the
// URL on the landing page, so it must be captured immediately.

const UTM_KEYS = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content'];
const MAX_AGE_SECONDS = 90 * 24 * 60 * 60; // 90 days

/**
 * Write a cookie with a 90-day expiry at the root path. No `domain=` attribute —
 * let the browser default to the current host (so subdomains don't interfere).
 */
function setTrackingCookie(name, value) {
    // Cookie values can contain reserved chars (the gclid is base64-like); encode
    // so they round-trip, and so PHP's $_COOKIE receives the decoded value.
    document.cookie = `${name}=${encodeURIComponent(value)}; max-age=${MAX_AGE_SECONDS}; path=/; SameSite=Lax`;
}

function getCookie(name) {
    return document.cookie
        .split('; ')
        .find((row) => row.startsWith(`${name}=`));
}

function captureTrackingParams() {
    const params = new URLSearchParams(window.location.search);

    // gclid — first click wins: never overwrite an existing gclid cookie.
    const gclid = params.get('gclid');
    if (gclid && !getCookie('gclid')) {
        setTrackingCookie('gclid', gclid);
    }

    // utm_* — capture each independently when present in the URL.
    UTM_KEYS.forEach((key) => {
        const value = params.get(key);
        if (value) {
            setTrackingCookie(key, value);
        }
    });
}

captureTrackingParams();
